import { useTranslation } from 'react-i18next';

import { CameraStreamControlButton } from './CameraStreamControlButton.tsx';
import { getVideoPauseToggle } from './cameraStreamVideoPause.helpers.ts';
import { StyledPauseToggleHost } from './cameraStreamWidget.styles.ts';
import { useCameraStreamFrameControlsContext } from './cameraStreamWidgetWrapper/cameraStreamFrameControlsProvider/CameraStreamFrameControlsContext.ts';

type CameraStreamPauseToggleButtonProps = {
  isVideoPaused: boolean;
  onToggle: () => void;
  zIndex: number;
};

/** Bottom-right pause/resume control; mirrors the widget menu action for quick stream disconnect. */
export const CameraStreamPauseToggleButton = ({
  isVideoPaused,
  onToggle,
  zIndex,
}: CameraStreamPauseToggleButtonProps) => {
  const { frameControlsVisible } = useCameraStreamFrameControlsContext();
  const { t } = useTranslation('cameraControl');
  const { label, Icon: ToggleIcon } = getVideoPauseToggle(isVideoPaused, t);

  const isVisible = frameControlsVisible || isVideoPaused;

  return (
    <StyledPauseToggleHost $zIndex={zIndex} $visible={isVisible}>
      <CameraStreamControlButton icon={<ToggleIcon />} label={label} onClick={onToggle} />
    </StyledPauseToggleHost>
  );
};
